import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { settingsAPI } from '../services/api';

// Shown instead of the app while the account still has a temporary password —
// a new staff member's first sign-in, or after the owner reset it. The server
// refuses every other request (PASSWORD_CHANGE_REQUIRED) until this is done.
export default function ForcePasswordChange() {
  const { user, updateUser, logout } = useAuth();
  const [form, setForm]     = useState({ currentPassword: '', newPassword: '', confirmPassword: '' });
  const [error, setError]   = useState('');
  const [saving, setSaving] = useState(false);

  const set = (k) => (e) => { setForm(f => ({ ...f, [k]: e.target.value })); setError(''); };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.newPassword !== form.confirmPassword) { setError('New passwords do not match'); return; }
    if (form.newPassword.length < 8) { setError('New password must be at least 8 characters'); return; }
    if (!/[a-zA-Z]/.test(form.newPassword) || !/[^a-zA-Z]/.test(form.newPassword)) {
      setError('Use a letter and a number or symbol'); return;
    }
    if (form.newPassword === form.currentPassword) { setError('Choose a password different from the temporary one'); return; }
    setSaving(true);
    try {
      // The change revoked the old session; the server sets a fresh session
      // cookie on this response, so we just carry on.
      await settingsAPI.changePassword({
        currentPassword: form.currentPassword,
        newPassword: form.newPassword,
      });
      updateUser({ must_change_password: false });
    } catch (err) {
      setError(err.response?.data?.error || 'Could not change the password — check your connection and try again');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1.5rem' }}>
      <div className="card" style={{ width: '100%', maxWidth: 420 }}>
        <h1 className="page-title" style={{ marginBottom: '0.5rem' }}>Set your own password</h1>
        <p className="text-muted" style={{ marginBottom: '1.25rem' }}>
          Hi {user?.name?.split(' ')[0] || 'there'} — you signed in with a temporary password.
          Choose your own before you continue. Only you should know it.
        </p>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Temporary password</label>
            <input type="password" value={form.currentPassword} onChange={set('currentPassword')} required autoFocus autoComplete="current-password" />
          </div>
          <div className="form-group">
            <label>New password</label>
            <input type="password" value={form.newPassword} onChange={set('newPassword')} required autoComplete="new-password" minLength={8} />
          </div>
          <div className="form-group">
            <label>Confirm new password</label>
            <input type="password" value={form.confirmPassword} onChange={set('confirmPassword')} required autoComplete="new-password" minLength={8} />
          </div>
          {error && <p className="error-msg" style={{ marginBottom: '0.75rem' }}>{error}</p>}
          <button type="submit" className="btn-primary" style={{ width: '100%', padding: '0.8rem' }} disabled={saving}>
            {saving ? 'Saving…' : 'Save password & continue'}
          </button>
        </form>
        <button className="btn-ghost" style={{ width: '100%', marginTop: '0.75rem' }} onClick={() => logout({ force: true })}>
          Log out
        </button>
      </div>
    </div>
  );
}
